import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { AuthService } from 'app/core/authentication/services/auth.service';
import { BrowserService } from 'app/core/browser/services/browser.service';
import { UserService } from 'app/core/user/services/user.service';
import { SiteSettingsService } from 'app/site-settings/services/site-settings.service';
import { Subject, BehaviorSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { AppRoute } from 'app/app-layout/constants';
import { RouterRequest } from 'app/core/browser/models';
import { UserInterface } from 'app/core/user/models';
import { ErrorSSOSingleInterface } from 'app/site-settings/models/error-message';

@Component({
  selector: 'cz-sso-access-only',
  templateUrl: './sso-access-only.component.html',
  styleUrls: ['./sso-access-only.component.scss'],
})
export class SSOAccessOnlyComponent implements OnInit, OnDestroy {
  public agreementDeclined: boolean = false;
  public loggedInUser: UserInterface;
  public errorMessage: ErrorSSOSingleInterface;
  public errorSSOMessage$: BehaviorSubject<ErrorSSOSingleInterface>;
  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private readonly _browserService: BrowserService,
              private readonly _authService: AuthService,
              private _translateService: TranslateService,
              private _siteSettingsService: SiteSettingsService,
              public readonly sanitizer: DomSanitizer,
              private readonly _userService: UserService,
              private readonly _snackBar: MatSnackBar,
              private dialogRef: MatDialogRef<SSOAccessOnlyComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
                this.errorSSOMessage$ = new BehaviorSubject<ErrorSSOSingleInterface>(undefined);
              }

  public ngOnInit(): void {
    this._authService.getLoggedInUser().pipe(
      takeUntil(this.destroy$))
      .subscribe((user: UserInterface) => {
        if (!user) { return; }
        this.loggedInUser = user;
      });

    this.errorSSOMessage$.subscribe((errorMessage:ErrorSSOSingleInterface)=>{
      if(!errorMessage) return;
      this.errorMessage = errorMessage;
    });

    this._siteSettingsService.loadErrorSSOSingleMessage(this.data.messageId)
    .pipe(takeUntil(this.destroy$))
    .subscribe((errorSSOMessage: ErrorSSOSingleInterface) => {
      if (!errorSSOMessage) {
        return; }
      this.errorSSOMessage$.next(errorSSOMessage);
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public logout(): void {
    this.dialogRef.close();
    const navRequest: RouterRequest = new RouterRequest({ route: AppRoute.logout });
    this._browserService.to(navRequest);
  }
}
